export const SEARCH_HEIGHT = 36;
// const SEARCH_HEIGHT = noSearchScreen && isPhone ? 39 : 37;
export const HEADER_TEXT_HEIGHT_BASE = 45;
export const TITLE_HEIGHT_BASE = 52;
export const SPACE_BETWEEN_TITLE_AND_SEARCH_BASE = 15;
export const NOTCH_TOP_FALLBACK = 15;
